// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__28HnA","modal":"Modal_modal__1rmFi","input":"Modal_input__2K9kS","buttonsWrapper":"Modal_buttonsWrapper__1j6a_","button":"Modal_button__hZ_wd"};